<script setup lang="ts">
import { isNilOrEmpty } from '~/shared/utils/helpers';

interface Props {
  title: string;
  value?: any;
  clickable?: boolean;
}

const props = withDefaults(defineProps<Props>(), { clickable: false });
const emit = defineEmits(['click']);
</script>

<template>
  <div class="stats-card">
    <a-card class="statistic-card">
      <a-row align="middle">
        <a-col span="24">
          <div class="ant-statistic">
            <div
              class="ant-statistic-content"
              style="text-align: center; font-weight: 500; color: #5d5d5d"
            >
              <a
                v-if="clickable && !isNilOrEmpty(props.value)"
                href="#"
                @click.prevent="() => emit('click')"
              >
                {{ props.value }}
              </a>
              <span v-else>
                {{ !isNilOrEmpty(props.value) ? props.value : '-' }}</span
              >
            </div>
            <div
              class="ant-statistic-title"
              style="
                text-align: center;
                font-size: 11px;
                font-weight: bold;
                text-transform: uppercase;
                color: rgb(182 181 181);
                letter-spacing: 1px;
              "
            >
              {{ props.title }}
            </div>
          </div>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<style lang="less">
.stats-card .ant-statistic .ant-statistic-content {
  font-size: 42px;
}

.stats-card {
  height: 100%;
  & .ant-card {
    height: 100%;
    & .ant-card-body {
      height: 100%;
      & .ant-row {
        height: 100%;
      }
    }
  }
  & .ant-skeleton-paragraph {
    margin-bottom: 0;
  }
  & .ant-result {
    padding: 0;

    & .ant-result-icon {
      margin-bottom: 8px;
    }

    & .ant-result-icon > .anticon {
      font-size: 51px;
    }

    & .ant-result-title {
      font-size: 16px;
      font-weight: 500;
      color: #727272;
    }
  }
}
</style>
